import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { showInfoModal } from 'components/Modals/CommonModals';
import { CHAT_TAB, ChatTabType } from 'consts/app';
import MiniGame from 'features/home/components/BetForm/MiniGame';
import ResultChat from 'features/home/components/BetForm/ResultChat';
import CurrentGiveAwayModal from 'features/home/components/Modals/CurrentGiveAwayModal';
import useThemes from 'hooks/useThemes';
import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { setShowChatMobile } from 'redux/chatSlice';
import ChatBox from './ChatBox';
import LiveChat from './LiveChat';
import ScoreBoard from './ScoreBoard';

interface ChatContainerMobileProps {}

const ChatContainerMobile: React.FunctionComponent<ChatContainerMobileProps> = (props) => {
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const { currentTheme } = useThemes();
  const [activeTab, setActiveTab] = useState<number>(1);
  const [isMaximize, setIsMaximize] = useState<boolean>(false);
  const [isShowGiveawayModal, setIsShowGiveawayModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const onCloseChat = () => {
    setActiveTab(1);
    dispatch(setShowChatMobile(false));
  };

  const handleStreamingClick = () => {
    navigate('/streaming');
    onCloseChat();
  };

  const handleChangeChatTab = (tab: ChatTabType) => {
    if (tab.isComingSoon) {
      showInfoModal({
        title: t('popup.comingSoon.title'),
        content: t('popup.comingSoon.content'),
      });
    } else {
      setActiveTab(tab.key);
    }
  };

  return (
    <div className={`chat-container mobile-chat-container maximize`}>
      <div className="chat-title">
        <div>
          {CHAT_TAB.map((tab) => (
            <span
              key={tab.key}
              onClick={() => {
                if (activeTab !== tab.key) {
                  handleChangeChatTab(tab);
                }
              }}
              className={`tab_item ${activeTab === tab.key ? 'active-tab' : ''}`}
            >
              {t(tab.labelKey)}
            </span>
          ))}
        </div>
        <div className="chat-bar-tool">
          <div className="close-icon cursor-pointer " onClick={onCloseChat}>
            <IoClose />
          </div>
        </div>
      </div>
      <div className="chat-body">
        {activeTab === 1 && <ChatBox className="height-39" />}
        {activeTab === 2 && <LiveChat className="height-39" />}
        {activeTab === 3 && <ResultChat className="height-39" />}
        {activeTab === 4 && <MiniGame className="height-39" />}
        {activeTab === 5 && <ScoreBoard className="height-39" />}
      </div>
      <CurrentGiveAwayModal
        visible={isShowGiveawayModal}
        closeModal={() => setIsShowGiveawayModal(false)}
      />
    </div>
  );
};

export default ChatContainerMobile;
